// extracted by mini-css-extract-plugin
export default {"addressSection":"AT-z","disabled":"BT-z","sectionButtons":"CT-z","logo":"DT-z"};